import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { IsApprovedUser, isAuthenticated } from "../services/auth";

export const ProtectedRoute = () => {
    return isAuthenticated() ? <Outlet /> : <Navigate to="/" />;
};
